import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Anchor, Button, Checkbox, Flex, Stack, Text } from "@mantine/core";
import { AppModal } from "./AppModal";
import { useState } from "react";
import { useAcceptTermsConditionsMutation } from "../graphql/graphql";
import { bootstrapCurrentUser } from "../utils/Auth";
import { showErrorNotification } from "./Notifications";
export const AcceptTermsConditionsModal = ({ opened, close }) => {
    const [, acceptTermsConditions] = useAcceptTermsConditionsMutation();
    const [areTermsChecked, setAreTermsChecked] = useState(false);
    const [isPrivacyPolicyChecked, setIsPrivacyPolicyChecked] = useState(false);
    const isDisabled = !areTermsChecked || !isPrivacyPolicyChecked;
    const handleSubmit = async () => {
        const response = await acceptTermsConditions({});
        if (response.error) {
            showErrorNotification("There was an error accepting the terms and conditions.");
            return;
        }
        // The acceptTermsConditions mutation only returns a boolean, so the
        // stored `me-data` in local storage still has acceptedTermsConditionsAt
        // as null. Layout re-reads `me` from local storage on every route
        // change and passes it to Header, which re-opens this modal whenever
        // acceptedTermsConditionsAt is falsy. Refetching `me` here keeps the
        // local-storage copy in sync with the database so subsequent renders
        // do not re-trigger the modal.
        try {
            await bootstrapCurrentUser();
        }
        catch (error) {
            console.error("Failed to refresh current user after accepting terms and conditions.", error);
        }
        close();
    };
    return (_jsxs(AppModal, { title: "Accept Terms and Conditions", opened: opened, onClose: () => { }, children: [_jsxs(Stack, { gap: "xl", children: [_jsx(Text, { variant: "body", children: "To continue to use this application, please read through and accept the following:" }), _jsxs(Stack, { style: { gap: 5 }, children: [_jsx(Checkbox, { label: _jsxs(_Fragment, { children: ["I accept the", " ", _jsx(Anchor, { href: "https://therapprove.com/terms/", target: "_blank", children: "terms and conditions" })] }), color: "var(--mantine-color-primary-9)", checked: areTermsChecked, onChange: (event) => setAreTermsChecked(event.currentTarget.checked) }), _jsx(Checkbox, { label: _jsxs(_Fragment, { children: ["I accept the", " ", _jsx(Anchor, { href: "https://therapprove.com/privacy-policy/", target: "_blank", children: "privacy policy" })] }), color: "var(--mantine-color-primary-9)", checked: isPrivacyPolicyChecked, onChange: (event) => setIsPrivacyPolicyChecked(event.currentTarget.checked) })] })] }), _jsx(Flex, { justify: "center", children: _jsx(Button, { variant: "filled", mt: "3rem", disabled: isDisabled, onClick: handleSubmit, children: "Accept" }) })] }));
};
